
import Page from '@/Page.vue';
import { Component, Prop } from 'vue-property-decorator';
import ShiftManagementCalendar from '@/libs/shifts/components/ShiftManagementCalendar.vue';
import ShiftManagementDetail from '@/libs/shifts/components/ShiftManagementDetail.vue';
import { Guid } from '@/libs/common/functions/guid';
import ShiftDetailDialog from '@/libs/shifts/components/ShiftDetailDialog.vue';

@Component({
    components: { ShiftDetailDialog, ShiftManagementDetail, ShiftManagementCalendar },
})
export default class LocationShifts extends Page {
    @Prop() locationId!: string;
    activeShift: string | null = null;

    created() {
        const shiftQS = this.getQuery('activeShift', true);
        if (shiftQS && shiftQS!.length > 0 && shiftQS != Guid.EmptyGuid()) {
            this.activeShift = shiftQS;
        }
    }

    onShiftClick(shiftId: string | null) {
        this.activeShift = shiftId;
        this.setQuery('activeShift', shiftId, true);
    }
}
